<template>
    <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
        role="document"
    >
        <div class="modal-content">
            <div class="modal-header border-0 p-4">
                <modal-close />
                <div class="modal-title">
                    <h2 class="h3 pt-1 mb-0">Usuwanie użytkownika</h2>
                </div>
            </div>
            <div class="modal-body p-4 border-top">
                <div class="c-service__basic">
                    <div>
                        Czy potwierdzasz usunięcie konta użytkownika
                        <b>[{{ login }}]</b> ?
                        <br />
                        Użytkownik straci dostęp do Panelu Detalisty.
                    </div>
                    <div
                        class="modal-footer col-12 d-flex justify-content-center mt-4"
                    >
                        <button
                            type="button"
                            class="btn btn-outline ml-2"
                            data-dismiss="modal"
                            @click="closeModal"
                        >
                            Anuluj
                        </button>
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                            @click="deleteUser"
                        >
                            Usuń
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        closeModal() {
            this.$store.dispatch('toggleModal', false)
        },
        deleteUser() {
            this.$store.dispatch('deleteStoreUser', {
                location_user_id: this.$store.getters.modalState.args.id
            })
        }
    },
    computed: {
        login() {
            return this.$store.getters.modalState.args.login
        }
    }
}
</script>
